import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { useMemo, memo, useContext, } from 'react';
import styleUtils from '../../styles/styleUtils';
import theme from '../../styles/theme';
import useLinkStyles from '../../styles/useLinkStyles';
import { TextLinkInputStateContext } from '../../utils/InputStateContext';
import { Icon, } from '../Icon/index';
import { textLinkIconAlignments, textLinkSizes, textLinkTypes, } from './constants';
const iconSizes = {
    [textLinkSizes.extraSmall]: 'extraSmall',
    [textLinkSizes.large]: 'small',
    [textLinkSizes.medium]: 'extraSmall',
    [textLinkSizes.small]: 'extraSmall',
};
const iconAlignmentStyles = {
    [textLinkIconAlignments.left]: css `
    margin-left: ${theme.spacing.base};
    margin-right: 0;
    order: 2;
  `,
    [textLinkIconAlignments.right]: css `
    margin-left: 0;
    margin-right: ${theme.spacing.base};
  `,
};
const TextLinkContent = ({ className, disabled, icon = undefined, iconAlignment = textLinkIconAlignments.left, size = textLinkSizes.medium, text = '', type = textLinkTypes.primary, }) => {
    const { isFocused, } = useContext(TextLinkInputStateContext);
    const linkStyles = useLinkStyles({
        disabled,
        size,
        type,
    });
    const containerStyles = useMemo(() => (css `
        ${isFocused && styleUtils.focusVisibleStyles}
        align-items: center;
        display: inline-flex;
      `), [
        isFocused,
    ]);
    const textLinkContentStyles = useMemo(() => (css `
        ${linkStyles}
        ${iconAlignmentStyles[iconAlignment]}
        ${!icon && css `
          align-self: baseline;
          margin: 0;
        `}
      `), [
        iconAlignment,
        icon,
        linkStyles,
    ]);
    return (_jsxs("div", Object.assign({ css: containerStyles }, { children: [text
                ? (_jsx("span", Object.assign({ className: className, css: textLinkContentStyles }, { children: text })))
                : null, icon
                ? (_jsx(Icon, { size: iconSizes[size], type: icon }))
                : null] })));
};
const MemoizedTextLinkContent = memo(TextLinkContent);
export { MemoizedTextLinkContent as TextLinkContent };
// MC-1068 Temporary hack for Storybook.
export default TextLinkContent;
